import { Badge } from "@/shared/ui/badge";
import { Button } from "@/shared/ui/button";
import type { Agreement, QueueItem, SubmitResult } from "../types";

const SEV_LABEL: Record<string, string> = { critical: "Critical", high: "High", medium: "Medium", low: "Low" };

// Disagreement is celebrated, never penalized — it's the valuable signal.
const MSG: Record<Agreement, string> = {
  agree: "In sync ✅",
  partial: "Sharp eye 👁 — you flagged a different severity",
  disagree: "Sharp eye 👁 — you caught something to teach the AI",
  unscorable: "Noted 📷 — we'll flag this image as too poor to assess",
};

export function RewardReveal({
  item,
  result,
  revealOur,
  onNext,
}: {
  item: QueueItem;
  result: SubmitResult;
  revealOur: boolean;
  onNext: () => void;
}) {
  return (
    <div className="space-y-3 rounded-lg border border-border/50 bg-muted/20 p-4">
      <p className="text-lg font-semibold text-foreground">{MSG[result.agreement]}</p>
      {revealOur && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <span>Our assessment was</span>
          <Badge variant="secondary">
            {item.our
              ? `${item.our.title}${item.our.severity ? ` — ${SEV_LABEL[item.our.severity]}` : ""}`
              : "No deficiency"}
          </Badge>
        </div>
      )}
      <p className="text-sm text-muted-foreground">
        +{result.reward.points_awarded} points · streak {result.reward.current_streak} · {result.reward.labels_count}{" "}
        labeled
      </p>
      {result.reward.new_badges.length > 0 && (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-medium text-foreground">Badge unlocked!</span>
          {result.reward.new_badges.map((b) => (
            <Badge key={b}>{b}</Badge>
          ))}
        </div>
      )}
      <Button onClick={onNext}>Next →</Button>
    </div>
  );
}
